<div class="agpr-regionPickerField agpr-formField">
    <div
        class="agpr-regionPickerField-heading agpr-formField-heading"
    >
        <span class="agpr-regionPickerField-headingLabel">
            {{ 'Reports.regionFocus' | localize }}
        </span>
        <span
            role="img"
            class="agpr-infoIconStyle fa-regular fa-circle-info"
            agprTooltip="Reports.regionFocusToolTip"
        ></span>
    </div>

    <div class="agpr-regionPickerField-region">
        <agpr-dropdown
            styleClass="agpr-regionPickerField-geographyScale"
            [id]="id + '.geographyScale.Dropdown'"
            [options]="geographyScaleOptions"
            [ngModel]="selectedGeographyScaleOption"
            (ngModelChange)="scaleUpdated($event.value)"
            ariaLabel="Reports.selectRegion"
        >
        </agpr-dropdown>
        <!-- TODO : Modifying the dropdown value with arrow keys does not
        update the disabled flag until you blur out of the dropdown.  Revisit
        after replaced with our inhouse dropdown if it's still a thing -->
        <agpr-autocomplete
            class="agpr-regionPickerField-regionOptions"
            [id]="id + '.autocomplete'"
            [suggestions]="suggestions$"
            labelField="label"
            [dropdown]="true"
            [placeholder]="regionOptionsPlaceholder"
            [(ngModel)]="selectedRegion"
            [clearOnBlur]="false"
            (itemSelected)="selectedRegionUpdated($event)"
            [disabled]="!regionOptions?.length"
            ariaLabel="Common.country"
        >
        </agpr-autocomplete>
    </div>
</div>
